<template>
    <div id="container" :class="['sub-container', 'bg', !showBtm ? 'nav_close' : '']">
        <div class="container_inner">
            <div class="sc03 high">
                <h3><span class="tit-st01"> <b>데이터 강남 플랫폼</b><br></span></h3>
<!--                <div class="sub_txt pdl-24">모든 행정데이터를 공개하는 열린 구청장실</div>-->

                <div class="sc03_sub_area">

                    <div class="data_population2">
                        <div class="data">
                            <div class="titleid">
                                <span class="blueline"></span><span class="grayline"></span>
                            </div>

                            <div class="system01 mt-10 "><!-- d4k-hidden -->
                                <h4>시스템 소개</h4>
                                <div class="back">
                                    <p class="txt1"><span>#구정을 한눈에</span>   <span>#정책공개</span>   <span>#데이터분석</span>   <span>#시각화</span>   <span>#구민관심</span></p>
                                    <p class="txt2">구정 현황을 데이터로 한눈에 본다</p>
                                </div>
                                <div class="info">데이터 강남 플랫폼은 안전, 도로, 대기 등 실시간 도시현황, 공공데이터, 구정 주요 사업을 확인할 수 있습니다.</div>
                            </div>

                            <!--
                            <div class="system01 mt-10 d4k-visible">
                                <h4>시스템 소개</h4>
                                <div class="video_player">
                                    <iframe id="video" width="1120" height="630"
                                        v-if="$_WC.viewScale > 1"
                                        :src="videoSrc" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="allowfullscreen"></iframe>
                                </div>
                            </div>
                            -->

                            <div class="system02">
                                <h4>시스템 특징</h4>
                                <div class="system_map m-visible"><img src="@/assets/images/sub/id_system_m.png" alt=""></div>
                                <div class="system_map pc-visible"><img src="@/assets/images/sub/id_system.png" alt=""></div>
                            </div>

                            <div class="system03">
                                <h4>구성메뉴</h4>
                                <ul>
                                    <li>
                                        <div class="system_menu">
                                            <p><i class="i01"></i>실시간 온택트 리더 열린 구청장실</p>
                                            <dl>
                                                <dt><a :href="$_WC.cp + 'realtime'">실시간 도시현황</a></dt>
                                                <dd>구조‧구급, 미세먼지, 도로공사 등 안전, 도로, 대기, 상수도의 실시간 현장 정보</dd>
                                            </dl>
                                        </div>
                                    </li>

                                    <li>
                                        <div class="system_menu">
                                            <p><i class="i02"></i>대한민국 1등 특별구 디지털도시 강남</p>
                                            <dl>
                                                <dt><a :href="$_WC.cp + 'biz'">대한민국 1등 특별구 디지털도시 강남</a></dt>
                                                <dd>공약/역점/스마트도시사업 추진현황 정보</dd>
                                                <dd>도서관, 복지시설, 실내구호소 등 강남생활지도</dd>
                                            </dl>
                                        </div>
                                    </li>

                                    <li>
                                        <div class="system_menu">
                                            <p><i class="i03"></i>지표로 보는 데이터 강남</p>
                                            <dl>
                                                <dt><a :href="$_WC.cp + 'indicator'">지표로 보는 데이터 강남</a></dt>
                                                <dd>행정, 경제, 복지, 교육 등 다양한 분야의 지표 차트화</dd>
                                            </dl>
                                        </div>
                                    </li>

                                    <li>
                                        <div class="system_menu">
                                            <p><i class="i04"></i>강남브리핑</p>
                                            <dl>
                                                <dt><a :href="$_WC.cp + 'news'">구민과 소통하는 강남브리핑</a></dt>
                                                <dd>코로나19브리핑, 정책브리핑, 영상뉴스, 오늘의 포토로 구성된 강남의 새로운 소식</dd>
                                            </dl>
                                        </div>
                                    </li>

                                    <li>
                                        <div class="system_menu">
                                            <p><i class="i05"></i>데이터로 분석한 구정</p>
                                            <dl>
                                                <dt><a :href="$_WC.cp + 'read'">데이터로 분석한 구정</a></dt>
                                                <dd>구정데이터를 쉽게 이해할 수 있도록 데이터를 풀어서 설명해주는 코너</dd>
                                            </dl>
                                        </div>
                                    </li>

                                </ul>
                            </div>

                            <div class="system04">
                                <div class="ban_txt"><span>구민과 함께 꿈이 모이는 도시, 미래를 그리는</span><br>강남을 실현하겠습니다.</div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { $_TYPE, $_WC, $_ADM } from '@/confs/common.const';
import { mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters({
            showBtm: 'getShowBtm',
            videoInfo: 'getVideoInfo',
        }),
        videoSrc(){
            if(typeof this.videoInfo.val1 !== $_TYPE.UNDEF){
                let url = '//www.youtube.com/embed/' + this.videoInfo.val1;
                url += '?autoplay=1&amp;mute=1&amp;controls=1&amp;fs=0&amp;rel=0&amp;modestbranding=1';
                url += '&amp;playlist='+ this.videoInfo.val1 +'&amp;loop=1';
                return url;
            }
        },
    },
};
</script>
